import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import "./../../bindings/filtering";
function ReminderTicketModuleViewModel(parent) {
    var self = this;
    self.parent = parent;
    self.Bao = Bao;
    self.Initialized = ko.observable(false);
    self.DashboardUrl = ko.observable();
    self.TicketTypes = ko.observableArray([]);
    self.TicketTypeId = ko.observable();
    self.FilterTypes = ko.observableArray([]);
    self.Filter = ko.observable();
    self.CustomFilter = ko.observableArray();
    self.TicketCollection = ko.observableArray([]);
    self.TotalRows = ko.observable(0);
    self.PageSize = ko.observable(20);
    self.PageIndex = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.SelectedRow = ko.observable({});
    self.IsLoading = ko.observable(false);
    self.SelectRow = function (item) {
        self.SelectedRow(item);
        return true;
    };
    self.ShowAllTickets = ko.observable();
    self.ShowAllTickets.subscribe(function () {
        self.Load();
    });
    self.ShowAllTicketsVisible = ko.computed(function () {
        return Bao.Session.HasPermission("StartModuleReminderTicketSeeAll", window.SynosetApplicationId)();
    });
    self.ReminderTicketEnabled = ko.observable();
    self.ExpandedSearchIsOpen = ko.observable(false);
    self.DisplayTotalRows = ko.computed(function () {
        if (self.TotalRows() <= self.PageSize()) {
            return self.TotalRows();
        }
        else {
            return self.PageSize() + " / " + self.TotalRows();
        }
    });
    self.PageIndex.subscribe(function () {
        self.Load();
    });

    self.PageSize.subscribe(function () {
        self.PageIndex(0);
        self.Load();
    });

    self.Sorting.subscribe(function () {
        self.Load();
    });
    self.Filter.subscribe(function (item) {
        self.DashboardUrl("");
        $.each(self.FilterTypes(), function (index, row) {
            if (row.Key == item) {
                self.DashboardUrl(row.OpenUrl);
            }
        });
        self.Load();
    });
    self.TicketTypeId.subscribe(function () {
        self.Load();
    });
    self.CustomFilter.subscribe(function () {
        self.Load();
    });
    self.Load = function () {
        var def = $.Deferred();
        if (self.Initialized()) {
            self.IsLoading(true);
            Bao.post("SynosetStartModule/GetReminderTickets", JSON.stringify({
                ticketTypeId: self.TicketTypeId(),
                filter: self.Filter(),
                customFilter: self.ToHashObject(self.CustomFilter()),
                pageIndex: self.PageIndex(),
                pageSize: self.PageSize(),
                sorting: self.Sorting(),
                showAllTickets: self.ShowAllTickets()
            }), function (searchResult) {
                self.SelectedRow(null);
                self.TotalRows(0);
                self.TicketCollection([]);
                if (searchResult != null && searchResult.Models != null) {
                    self.TicketCollection(searchResult.Models);
                    self.TotalRows(searchResult.TotalRows);
                }
                def.resolve();
                self.IsLoading(false);
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    self.parent.Refresh = function () {
        self.Load();
    };
    self.init = function () {
        var def = $.Deferred();
        self.ShowAllTickets(false);
        $.when(Bao.post("SynosetStartModule/GetReminderTicketTypes", JSON.stringify({}), function (searchResult) {
            self.TicketTypes([]);
            if (searchResult != null) {
                self.TicketTypes(searchResult);
                if (self.parent != null && self.parent.Parameter() != null) {
                    var parameter = self.parent.Parameter().split(";");
                    if (parameter.length > 0) {
                        self.TicketTypeId(parameter[0]);
                    }
                }
            }
        }), Bao.post("SynosetStartModule/GetReminderTicketFilter", JSON.stringify({}), function (searchResult) {
            self.FilterTypes([]);
            if (searchResult != null) {
                self.FilterTypes(searchResult);
                if (self.parent != null && self.parent.Parameter() != null) {
                    var parameter = self.parent.Parameter().split(";");
                    if (parameter.length > 1) {
                        self.Filter(parameter[1]);
                    }
                }
            }
        })).then(function () {
            self.Initialized(true);
            def.resolve();
        });
        return def.promise();
    };
    self.loaded = function () {
        return self.Load();
    };
    self.ToHashObject = function (customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({
                Key: f,
                Value: ko.unwrap(customFilter[f])
            });
        }
        return returnValue;
    };
}
export default ReminderTicketModuleViewModel;